import { addMonths } from 'date-fns/addMonths';
import { format } from 'date-fns/format';
import { Reason } from 'src/modules/shared/modal/components/report/reportReasons';

export type ReportReasonRows = [string, number, string][]; // [date, value, reason]
type ReasonGroup = { reason: Reason, data: { date: string, value: number }[] };

// TODO: can be removed after one year in May 2026
export function mapOldToNewReason(reason: string): Reason {
  switch (reason) {
    case 'Other':
      return Reason.SomethingElse;
    case 'Potentially dangerous advice':
      return Reason.DangerousAdvice;
    case 'Underage user':
      return Reason.UnderageMember;
  }
  return reason as Reason;
}

export const groupDataByReason = (data: ReportReasonRows): ReasonGroup[] => {
  const map = new Map<string, ReasonGroup>();
  data.forEach(([date, value, reason]) => {
    const newReason = mapOldToNewReason(reason);
    if (map.has(newReason)) {
      map.get(newReason)!.data.push({ date, value });
    } else {
      map.set(newReason, { reason: newReason, data: [{ date, value }] });
    }
  });
  return Array.from(map.values());
};

export const getFullSetOfDates = (startDate: string, endDate: string): string[] => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const dates = [];
  let current = start;
  while (current <= end) {
    dates.push(format(current, 'yyyy-MM-dd'));
    current = addMonths(current, 1);
  }
  return dates;
};

export const getValues = (reasonGroups: ReasonGroup[], dates: string[]): number[][] => {
  // For each reason, we extract the value if it exists or we add 0 for missing data, to have 12 months of data
  return reasonGroups.map(reason => {
    const newArray: number[] = [];
    dates.forEach(date => {
      const dataPoint = reason.data.find(object => object.date === date);
      newArray.push(dataPoint?.value || 0);
    });
    return newArray;
  });
};
